import { HIDDEN_SELECTOR } from '../keyboard-nav-support';

function displayElementFor(el, { multiselect, excludeId }) {
  if (excludeId && el.id === excludeId) return null;

  return multiselect ? el.parentElement : el;
}

function matchMenuItem(el, { upperValue, multiselect, excludeId }) {
  let element = displayElementFor(el, { multiselect, excludeId });
  if (!element) return false;

  let isMatch = element.textContent.trim().toUpperCase().includes(upperValue);

  element.classList.toggle(HIDDEN_SELECTOR, !isMatch);

  return isMatch;
}

/**
 * Simple, case-insensitive text filter shared by every menu-based dropdown.
 *
 * Toggles the `HIDDEN_SELECTOR` class on each item's display element based on whether
 * its text content includes the provided value, and returns the list of matching items.
 *
 * @param {Element[]} elements the navigable item elements to filter
 * @param {string} value the current search/filter value
 * @param {object} [options]
 * @param {boolean} [options.multiselect] when true, the parent element of each item is toggled
 * @param {string} [options.excludeId] id of an item to skip (e.g. a "select all" option)
 * @returns {Element[]} the matching item elements
 */
export function filterMenuItemsByText(
  elements = [],
  value = '',
  { multiselect = false, excludeId } = {}
) {
  let upperValue = (value ?? '').toUpperCase();

  return elements.filter(el => matchMenuItem(el, { upperValue, multiselect, excludeId }));
}
